import { render, staticRenderFns } from "./Dispo.vue?vue&type=template&id=31c70ec4&scoped=true"
import script from "./Dispo.vue?vue&type=script&lang=js"
export * from "./Dispo.vue?vue&type=script&lang=js"
import style0 from "./Dispo.vue?vue&type=style&index=0&id=31c70ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c70ec4",
  null
  
)

export default component.exports